'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatusBanner = require('./components/StatusBanner.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StatusBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/status-banner/index.js
// module id = 1344
// module chunks = 0